module.exports = __webpack_public_path__ + "static/media/Learn-Check-your-understanding-01.fedaf1c5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Learn-Check-your-understanding-01.mp3
// module id = 576
// module chunks = 0